import { render, staticRenderFns } from "./GuardiansInformation.vue?vue&type=template&id=15602300&scoped=true&"
import script from "./GuardiansInformation.vue?vue&type=script&lang=js&"
export * from "./GuardiansInformation.vue?vue&type=script&lang=js&"
import style0 from "./GuardiansInformation.vue?vue&type=style&index=0&id=15602300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15602300",
  null
  
)

export default component.exports